import React from 'react'

function GameBigCircle(props) {
    return (
        <div className={`${props.classBigCircle} ${props.win}`}>

        </div>
    )
}

export default GameBigCircle;
